<template>
  <div v-if="loading_page"></div>
  <div v-else id="invoice-POS">
    <div style="position: relative; height: 100dvh">
      <center>
        <!-- <div id="wb_Image1" style="position: absolute; left: 0px; top: 0px; width: 1029px; height: 1455px; z-index: 1; background-color: aqua;"> -->
        <div id="wb_Image1" style="position: absolute; left: 0px; top: -25px; width: 1029px; height: 1455px; z-index: 1">
          <!-- <div id="wb_Image1" style="position: absolute; left: 0px; top: 0px; width: 1029px; height: 1475px; z-index: 1"> -->
          <!-- <img :src="img_bg" id="Image1" alt="" width="1029" height="1474" /> -->
        </div>
        <input disabled type="text" :style="`position: absolute; left: ${290 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 2`" :value="data_store.store_personal_id[0]" />
        <input disabled type="text" :style="`position: absolute; left: ${311 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 3`" :value="data_store.store_personal_id[1]" />
        <input disabled type="text" :style="`position: absolute; left: ${332 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 4`" :value="data_store.store_personal_id[2]" />
        <input disabled type="text" :style="`position: absolute; left: ${353 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 5`" :value="data_store.store_personal_id[3]" />

        <input disabled type="text" :style="`position: absolute; left: ${376 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 9`" :value="data_store.store_personal_id[4]" />
        <input disabled type="text" :style="`position: absolute; left: ${396 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 8`" :value="data_store.store_personal_id[5]" />
        <input disabled type="text" :style="`position: absolute; left: ${417 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 7`" :value="data_store.store_personal_id[6]" />
        <input disabled type="text" :style="`position: absolute; left: ${438 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 6`" :value="data_store.store_personal_id[7]" />

        <input disabled type="text" :style="`position: absolute; left: ${459 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 14`" :value="data_store.store_personal_id[8]" />
        <input disabled type="text" :style="`position: absolute; left: ${482 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 13`" :value="data_store.store_personal_id[9]" />
        <input disabled type="text" :style="`position: absolute; left: ${504 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 12`" :value="data_store.store_personal_id[10]" />
        <input disabled type="text" :style="`position: absolute; left: ${526 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 11`" :value="data_store.store_personal_id[11]" />
        <input disabled type="text" :style="`position: absolute; left: ${548 + left}px; top: ${148 + top}px; width: 18px; height: 28px; z-index: 10`" :value="data_store.store_personal_id[12]" />

        <input disabled type="text" :style="`position: absolute; left: ${459 + left}px; top: ${183 + top}px; width: 18px; height: 28px; z-index: 19`" :value="data_store.store_code[0]" />
        <input disabled type="text" :style="`position: absolute; left: ${482 + left}px; top: ${183 + top}px; width: 18px; height: 28px; z-index: 18`" :value="data_store.store_code[1]" />
        <input disabled type="text" :style="`position: absolute; left: ${504 + left}px; top: ${183 + top}px; width: 18px; height: 28px; z-index: 17`" :value="data_store.store_code[2]" />
        <input disabled type="text" :style="`position: absolute; left: ${526 + left}px; top: ${183 + top}px; width: 18px; height: 28px; z-index: 16`" :value="data_store.store_code[3]" />
        <input disabled type="text" :style="`position: absolute; left: ${548 + left}px; top: ${183 + top}px; width: 18px; height: 28px; z-index: 15`" :value="data_store.store_code[4]" />

        <input disabled type="text" :style="`position: absolute; left: ${156 + left}px; top: ${210 + top}px; width: 198px; height: 22px; z-index: 22`" :value="data_store.store_name" />

        <input disabled type="text" :style="`position: absolute; left: ${358 + left}px; top: ${233 + top}px; width: 198px; height: 22px; z-index: 20`" :value="data_store.sub_district" />
        <input disabled type="text" :style="`position: absolute; left: ${358 + left}px; top: ${263 + top}px; width: 198px; height: 22px; z-index: 21`" :value="data_store.province" />
        <input disabled type="text" :style="`position: absolute; left: ${129 + left}px; top: ${233 + top}px; width: 165px; height: 22px; z-index: 23`" :value="data_store.address" />
        <input disabled type="text" :style="`position: absolute; left: ${88 + left}px; top: ${263 + top}px; width: 188px; height: 22px; z-index: 24`" :value="data_store.district" />
        <input disabled type="text" :style="`position: absolute; left: ${105 + left}px; top: ${293 + top}px; width: 451px; height: 22px; z-index: 25`" :value="data_store.tel" />

        <!-- -------- -->
        <div v-for="(item, i) in data_refund.product_list_first_page" :key="i">
          <!-- <input disabled type="text" :style="`position: absolute; left: ${66 + left}px; top: ${435 + list_top[i] + top}px; width: 91px; height: 22px; z-index: 26`" :value="data_refund.invoice_code" /> -->
          <input disabled type="text" :style="`position: absolute; left: ${66 + left}px; top: ${435 + list_top[i] + top}px; width: 91px; height: 22px; z-index: 26`" :value="data_refund.invoice_code" />
          <input disabled type="text" :style="`position: absolute; left: ${185 + left}px; top: ${435 + list_top[i] + top}px; width: 194px; height: 22px; z-index: 49`" :value="item.product_name" />
          <input disabled type="text" :style="`position: absolute; left: ${408 + left}px; top: ${435 + list_top[i] + top}px; width: 25px; height: 22px; z-index: 61`" :value="item.qty" />
          <input disabled type="text" :style="`position: absolute; left: ${458 + left}px; top: ${435 + list_top[i] + top}px; width: 105px; height: 22px; z-index: 73; text-align: end;`" :value="formatPrice(item.total)" />
        </div>
        <!-- -------- -->

        <input disabled type="text" :style="`position: absolute; left: ${353 + left}px; top: ${808 + top}px; width: 105px; height: 22px; z-index: 77`" :value="data_refund.product_other_page.length + 1" />
        <input v-if="data_refund.product_other_page.length != 0" disabled type="text" :style="`position: absolute; left: ${458 + left}px; top: ${808 + top}px; width: 105px; height: 22px; z-index: 77; text-align: end;`" :value="formatPrice(data_refund.sum_total_other_page)" />
        <input disabled type="text" :style="`position: absolute; left: ${458 + left}px; top: ${848 + top}px; width: 105px; height: 22px; z-index: 76; text-align: end;`" :value="formatPrice(data_refund.total_payment)" />
        <input disabled type="text" :style="`position: absolute; left: ${458 + left}px; top: ${883 + top}px; width: 105px; height: 22px; z-index: 75; text-align: end;`" :value="formatPrice(data_refund.total_vat)" />
        <input
          disabled
          type="text"
          :style="`position: absolute; left: ${458 + left}px; top: ${918 + top}px; width: 105px; height: 22px; z-index: 74; text-align: end;`"
          :value="formatPrice(data_refund.total_vat_refund)"
        />

        <input disabled type="text" :style="`position: absolute; left: ${684 + left}px; top: ${160 + top}px; width: 293px; height: 22px; z-index: 78`" :value="data_refund.tourist_name" />
        <input disabled type="text" :style="`position: absolute; left: ${649 + left}px; top: ${200 + top}px; width: 328px; height: 22px; z-index: 79`" :value="data_refund.nationlity_name" />
        <input disabled type="text" :style="`position: absolute; left: ${666 + left}px; top: ${230 + top}px; width: 311px; height: 22px; z-index: 80`" :value="data_refund.passport_no" />
        <input
          disabled
          type="text"
          :style="`position: absolute; left: ${659 + left}px; top: ${265 + top}px; width: 63px; height: 22px; z-index: 81`"
          :value="data_refund.arrival_date && data_refund.arrival_date.split('-')[2]"
        />
        <input
          disabled
          type="text"
          :style="`position: absolute; left: ${752 + left}px; top: ${265 + top}px; width: 134px; height: 22px; z-index: 82`"
          :value="data_refund.arrival_date && data_refund.arrival_date.split('-')[1]"
        />
        <input
          disabled
          type="text"
          :style="`position: absolute; left: ${913 + left}px; top: ${265 + top}px; width: 64px; height: 22px; z-index: 83`"
          :value="data_refund.arrival_date && parseInt(data_refund.arrival_date.split('-')[0]) + 543"
        />
        <input
          disabled
          type="text"
          :style="`position: absolute; left: ${684 + left}px; top: ${297 + top}px; width: 26px; height: 22px; z-index: 84`"
          :value="data_refund.departure_date && data_refund.departure_date.split('-')[2]"
        />
        <input
          disabled
          type="text"
          :style="`position: absolute; left: ${733 + left}px; top: ${297 + top}px; width: 34px; height: 22px; z-index: 85`"
          :value="data_refund.departure_date && data_refund.departure_date.split('-')[1]"
        />
        <input disabled type="text" :style="`position: absolute; left: ${896 + left}px; top: ${295 + top}px; width: 80px; height: 22px; z-index: 86`" :value="data_refund.flight_no" />
        <input
          disabled
          type="text"
          :style="`position: absolute; left: ${788 + left}px; top: ${297 + top}px; width: 40px; height: 22px; z-index: 87`"
          :value="data_refund.departure_date && parseInt(data_refund.departure_date.split('-')[0]) + 543"
        />
        <textarea
          disabled
          :style="`position: absolute; left: ${582 + left}px; top: ${367 + top}px; width: 395px; height: 48px; z-index: 88; overflow: hidden; line-height: 1.75;`"
          rows="1"
          cols="42"
          v-model="data_refund.address"
        ></textarea>
        <input disabled type="text" :style="`position: absolute; left: ${641 + left}px; top: ${435 + top}px; width: 148px; height: 22px; z-index: 89`" :value="data_refund.postcode" />
        <input disabled type="text" :style="`position: absolute; left: ${837 + left}px; top: ${435 + top}px; width: 140px; height: 22px; z-index: 90`" :value="data_refund.city" />
        <input disabled type="text" :style="`position: absolute; left: ${641 + left}px; top: ${465 + top}px; width: 336px; height: 22px; z-index: 91`" :value="data_refund.country" />
        <input disabled type="text" :style="`position: absolute; left: ${641 + left}px; top: ${500 + top}px; width: 336px; height: 22px; z-index: 92`" :value="data_refund.email" />

        <div v-if="data_refund.refund_type == 0" :style="`position: absolute; left: ${578 + left}px; top: ${575 + top}px; width: 20px; height: 20px; z-index: 93;`">
          <!-- <div :style="`position: absolute; left: ${578 + left}px; top: ${575 + top}px; width: 20px; height: 20px; z-index: 93;`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>
        <div v-else-if="data_refund.refund_type == 1" :style="`position: absolute; left: ${578 + left}px; top: ${607 + top}px; width: 20px; height: 20px; z-index: 94`">
          <!-- <div :style="`position: absolute; left: ${578 + left}px; top: ${607 + top}px; width: 20px; height: 20px; z-index: 94`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>
        <div v-else-if="data_refund.refund_type == 2" :style="`position: absolute; left: ${578 + left}px; top: ${660 + top}px; width: 20px; height: 20px; z-index: 95`">
          <!-- <div :style="`position: absolute; left: ${578 + left}px; top: ${660 + top}px; width: 20px; height: 20px; z-index: 95`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <div v-if="data_refund.refund_type == 1 && data_refund.draft_type == 0" :style="`position: absolute; left: ${600 + left}px; top: ${638 + top}px; width: 20px; height: 20px; z-index: 96`">
          <!-- <div  :style="`position: absolute; left: ${600 + left}px; top: ${638 + top}px; width: 20px; height: 20px; z-index: 96`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <div v-else-if="data_refund.refund_type == 1 && data_refund.draft_type == 1" :style="`position: absolute; left: ${703 + left}px; top: ${637 + top}px; width: 20px; height: 20px; z-index: 97`">
          <!-- <div  :style="`position: absolute; left: ${703 + left}px; top: ${637 + top}px; width: 20px; height: 20px; z-index: 97`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <div v-else-if="data_refund.refund_type == 1 && data_refund.draft_type == 2" :style="`position: absolute; left: ${802 + left}px; top: ${636 + top}px; width: 20px; height: 20px; z-index: 98`">
          <!-- <div  :style="`position: absolute; left: ${802 + left}px; top: ${636 + top}px; width: 20px; height: 20px; z-index: 98`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <div v-else-if="data_refund.refund_type == 1 && data_refund.draft_type == 3" :style="`position: absolute; left: ${885 + left}px; top: ${636 + top}px; width: 20px; height: 20px; z-index: 99`">
          <!-- <div  :style="`position: absolute; left: ${885 + left}px; top: ${636 + top}px; width: 20px; height: 20px; z-index: 99`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <div v-if="data_refund.refund_type == 2 && data_refund.credit_type == 0" :style="`position: absolute; left: ${600 + left}px; top: ${691 + top}px; width: 20px; height: 20px; z-index: 103`">
          <!-- <div  :style="`position: absolute; left: ${600 + left}px; top: ${691 + top}px; width: 20px; height: 20px; z-index: 103`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <div v-else-if="data_refund.refund_type == 2 && data_refund.credit_type == 1" :style="`position: absolute; left: ${702 + left}px; top: ${690 + top}px; width: 20px; height: 20px; z-index: 102`">
          <!-- <div  :style="`position: absolute; left: ${702 + left}px; top: ${690 + top}px; width: 20px; height: 20px; z-index: 102`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <div v-else-if="data_refund.refund_type == 2 && data_refund.credit_type == 2" :style="`position: absolute; left: ${801 + left}px; top: ${689 + top}px; width: 20px; height: 20px; z-index: 101`">
          <!-- <div  :style="`position: absolute; left: ${801 + left}px; top: ${689 + top}px; width: 20px; height: 20px; z-index: 101`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <div v-else-if="data_refund.refund_type == 2 && data_refund.credit_type == 3" :style="`position: absolute; left: ${885 + left}px; top: ${688 + top}px; width: 20px; height: 20px; z-index: 100`">
          <!-- <div  :style="`position: absolute; left: ${885 + left}px; top: ${688 + top}px; width: 20px; height: 20px; z-index: 100`"> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>

        <input disabled type="text" :style="`position: absolute; left: ${775 + left + 8}px; top: ${711 + top}px; width: 202px; height: 22px; z-index: 104`" :value="data_refund.name_of_credit" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${668 + left + 5}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 105`" :value="data_refund.card_no[0]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${689 + left + 5}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 106`" :value="data_refund.card_no[1]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${709 + left + 5}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 107`" :value="data_refund.card_no[2]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${730 + left + 5}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 108`" :value="data_refund.card_no[3]" />

        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${751 + left + 5}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 112`" :value="data_refund.card_no[4]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${771 + left + 8}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 111`" :value="data_refund.card_no[5]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${792 + left + 8}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 110`" :value="data_refund.card_no[6]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${813 + left + 8}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 109`" :value="data_refund.card_no[7]" />

        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${835 + left + 8}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 120`" :value="data_refund.card_no[8]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${855 + left + 10}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 119`" :value="data_refund.card_no[9]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${876 + left + 10}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 118`" :value="data_refund.card_no[10]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${897 + left + 10}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 117`" :value="data_refund.card_no[11]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${918 + left + 10}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 116`" :value="data_refund.card_no[12]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${938 + left + 10}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 115`" :value="data_refund.card_no[13]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${959 + left + 10}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 114`" :value="data_refund.card_no[14]" />
        <input v-if="data_refund.card_no" disabled type="text" :style="`position: absolute; left: ${980 + left + 10}px; top: ${748 + top}px; width: 16px; height: 20px; z-index: 113`" :value="data_refund.card_no[15]" />

        <input disabled type="text" :style="`position: absolute; left: ${678 + left}px; top: ${780 + top}px; width: 299px; height: 22px; z-index: 121`" :value="data_refund.expiry_date" />
        <!-- <input type="text" :style="`position: absolute; left: ${746 + left}px; top: ${809 + top}px; width: 160px; height: 22px; z-index: 122`" value="ss" /> -->
        <!-- <input type="text" :style="`position: absolute; left: ${711 + left}px; top: ${839 + top}px; width: 195px; height: 22px; z-index: 123`" value="dd" /> -->
        <!-- <input type="text" :style="`position: absolute; left: ${341 + left}px; top: ${1030 + top}px; width: 195px; height: 22px; z-index: 124`" value="ff" /> -->

        <input
          disabled
          type="text"
          :style="`position: absolute; left: ${318 + left}px; top: ${1090 + top}px; width: 227px; height: 22px; z-index: 125`"
          :value="new Date().getDate() + '/' + parseInt(new Date().getMonth()) + 1 + '/' + (parseInt(new Date().getFullYear()) + 543)"
        />
      </center>
    </div>

    <div v-for="(num, i) in data_refund.product_other_page.length" :key="i" style="position: relative; height: 100dvh">
      <Pos_invoices_tax_refund_pdf_other
        :store_personal_id="data_store.store_personal_id"
        :store_code="data_store.store_code"
        :data_other="data_refund.product_other_page[num - 1]"
        :num_page="num + 1"
        :num_all_page="data_refund.product_other_page.length + 1"
        :invoice_code="data_refund.invoice_code"
      />
    </div>
  </div>
  <!--End Invoice-->
</template>

<script>
4;

import img_bg from "@/assets/arin_assets/S__70279436.jpg";

// import img_arin from "@/assets/arin_assets/pharmacare-black.png";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";

import Pos_invoices_tax_refund_pdf_other from "@/components/adminArin/pos_system/pos/Pos_invoices_tax_refund_pdf_other";

export default {
  components: {
    Pos_invoices_tax_refund_pdf_other,
  },
  data() {
    return {
      loading_page: true,
      img_bg: img_bg,
      left: 0,
      top: -23,
      // top: 0,
      list_top: [0, 33, 63, 93, 123, 155, 183, 213, 243, 278, 308, 338],
      // img_arin: img_arin,
      data_refund: {},
      data_store: {},
      // data_frist_page: [],
      data_other_page: [],
      // data_total_other_page: 0.0,
      data_num_page: 0,
    };
  },
  methods: {
    formatPrice,
    async getData() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      let store_id = this.$store.state.store_arin.user_data.store_id;
      // http://192.46.229.30:81/api/stores/detail/1
      await HTTP_ARIN.get("/stores/detail/" + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.data_store = res.data.storeDetail;
          // console.log(this.data_store);
        }
      });

      let id = parseInt(this.$route.query.id);
      await HTTP_ARIN.get("/tax/refund/" + id, config).then((res) => {
        if (res.data.successful === true) {
          this.data_refund = res.data.data;
          // console.log(this.data_refund.sum_total_other_page);
          // this.data_frist_page = this.data_refund.product_list.filter((v, i) => i < 12);
          this.data_other_page = this.data_refund.product_list.filter((v, i) => i >= 12);
          this.data_num_page = Math.ceil(this.data_other_page.length / 16) + 1;
          // this.data_total_other_page = this.data_other_page.reduce((total, item) => total + parseFloat(item.total), 0);
          // console.log(this.data_refund);
        }
      });

      this.loading_page = false;
    },
    async print() {
      document.getElementById("invoice-POS").innerHTML;
      // document.body.innerHTML = printContents;
      const originalContents = document.body.innerHTML;
      window.print();

      window.onafterprint = function () {
        document.body.innerHTML = originalContents;
        window.close();
      };
    },
  },
  async mounted() {
    await this.getData();
    this.print();
  },
};
</script>

<style scoped>
#wb_Image1 {
  vertical-align: top;
}
#Image1 {
  border: 0px solid #000000;
  border-radius: 0px;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

input,
textarea {
  line-height: 17px;
  margin: 0;
  /* border: 1px solid #dee2e6; */
  border-radius: 4px;
  /* background-color: #ffffff; */
  background-image: none;
  color: #212529;
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  font-size: 13px;
  text-align: left;
  padding: 4px 4px 4px 4px;
  resize: none;
}

input:focus {
  /* border-color: #66afe9; */
  /* box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.075), 0px 0px 8px rgba(102, 175, 233, 0.6); */
  outline: 0;
}
</style>
